var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDinersIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 39,
    viewBox: "0 0 59 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_5433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 0.5H5C2.51472 0.5 0.5 2.51472 0.5 5V34C0.5 36.4853 2.51472 38.5 5 38.5H54C56.4853 38.5 58.5 36.4853 58.5 34V5C58.5 2.51472 56.4853 0.5 54 0.5Z",
    stroke: "#3D2C06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2692 9H27.0942C21.0097 8.99696 16 13.5342 16 20.0952C16 26.0976 21.0087 31.0303 27.0942 30.9999H32.2692C38.2827 31.0282 43.771 26.0956 43.771 20.0952C43.771 13.5322 38.2817 8.99696 32.2692 9ZM27.1186 30.0529C21.5583 30.0498 17.0514 25.542 17.0504 19.9807C17.0514 14.4173 21.5583 9.90948 27.1186 9.90847C32.6799 9.90948 37.1877 14.4183 37.1877 19.9807C37.1877 25.542 32.6809 30.0498 27.1186 30.0529Z",
    fill: "#3D2C06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4023 14.022V25.9385C31.7972 25.0168 33.4975 22.7011 33.5016 19.9797C33.4985 17.2604 31.7972 14.9406 29.4023 14.022Z",
    fill: "#3D2C06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7378 19.9797C20.7418 22.698 22.4381 25.0148 24.833 25.9354V14.022C22.4391 14.9436 20.7429 17.2614 20.7378 19.9797Z",
    fill: "#3D2C06"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_5433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersIcon);
export default __webpack_public_path__ + "static/media/dinersIcon.7fea84f47caf6bfcf20b371604ec4414.svg";
export { ForwardRef as ReactComponent };